import { render } from "./DrawingForm.vue?vue&type=template&id=05162d2c&scoped=true"
import script from "./DrawingForm.vue?vue&type=script&lang=js"
export * from "./DrawingForm.vue?vue&type=script&lang=js"

import "./DrawingForm.vue?vue&type=style&index=0&id=05162d2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05162d2c"]])

export default __exports__